import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

const SystemErrorBlock = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  return (
    <div className="flex flex-col gap-1" aria-label="message-system-error">
      <p className={typographyVariants({ variant: 'h6', color: 'error' })}>
        {t('Something went wrong due to a technical problem.')}
      </p>
      <div className="flex flex-row gap-2">
        <p className={typographyVariants({ variant: 'bodyLong01' })}>
          {t('If this issue persists, please contact our customer support at')}
        </p>
        <a
          className={cn(
            'underline',
            typographyVariants({ variant: 'bodyLong01', color: 'link' }),
          )}
          href="mailto:support@mint.ai"
        >
          support@mint.ai
        </a>
      </div>
    </div>
  );
};

export { SystemErrorBlock };
